import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./OptionSelect.module.css";

const OptionSelect = ({ onChange, resetFlag }) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState({
    course: "",
    lady: false,
  });

  useEffect(() => {
    // resetFlagがtrueになったら、オプションをリセットする
    setOptions({
      course: "",
      lady: false,
    });
  }, [resetFlag]);

  const handleInputChange = (e) => {
    const { name, checked, type } = e.target;
    let value = false;
    if (type === "checkbox") {
      value = checked;
    } else if (type === "select-one") {
      value = e.target.value;
    } else {
      if (options.course === e.target.id) {
        value = "";
        e.target.checked = false;
      } else {
        value = e.target.id;
      }
    }
    setOptions((prev) => {
      // 新しい状態を生成
      const newOptions = { ...prev, [name]: value };
      // 非同期に新しい状態を親コンポーネントに渡す
      setTimeout(() => onChange(newOptions), 0);
      return newOptions;
    });
  };

  return (
    <div>
      <div className={styles.options}>
        <div className={styles.optionGroup1}>
          <div className={styles.optionsLabel}>{t("健診種別")}</div>
          <div>
            <input
              type="radio"
              id="A"
              name="course"
              checked={options.course === "A"}
              className={styles.radioInput}
              onChange={handleInputChange}
              onClick={handleInputChange}
            />
            <label htmlFor="A" className={styles.radioLabel}>
              {t("生活習慣病A")}
            </label>
            <input
              type="radio"
              id="B"
              name="course"
              checked={options.course === "B"}
              className={styles.radioInput}
              onChange={handleInputChange}
              onClick={handleInputChange}
            />
            <label htmlFor="B" className={styles.radioLabel}>
              {t("生活習慣病B")}
            </label>
            <input
              type="radio"
              id="C"
              name="course"
              checked={options.course === "C"}
              className={styles.radioInput}
              onChange={handleInputChange}
              onClick={handleInputChange}
            />
            <label htmlFor="C" className={styles.radioLabel}>
              {t("女性生活習慣病C")}
            </label>
            <input
              type="radio"
              id="B1"
              name="course"
              checked={options.course === "B1"}
              className={styles.radioInput}
              onChange={handleInputChange}
              onClick={handleInputChange}
            />
            <label htmlFor="B1" className={styles.radioLabel}>
              {t("生活習慣病B1")}
            </label>
            <input
              type="radio"
              id="D"
              name="course"
              checked={options.course === "D"}
              className={styles.radioInput}
              onChange={handleInputChange}
              onClick={handleInputChange}
            />
            <label htmlFor="D" className={styles.radioLabel}>
              {t("人間ドック")}
            </label>
            <input
              type="radio"
              id="L"
              name="course"
              checked={options.course === "L"}
              className={styles.radioInput}
              onChange={handleInputChange}
              onClick={handleInputChange}
            />
            <label htmlFor="L" className={styles.radioLabel}>
              {t("人間ドック（婦人科含む）")}
            </label>
            <input
              type="radio"
              id="toshinkyo_tokutei"
              name="course"
              checked={options.course === "toshinkyo_tokutei"}
              className={styles.radioInput}
              onChange={handleInputChange}
              onClick={handleInputChange}
            />
            <label htmlFor="toshinkyo_tokutei" className={styles.radioLabel}>
              {t("特定健診")}
            </label>
          </div>
        </div>
        <div className={styles.optionGroup3}>
          <div className={styles.optionsLabel}>{t("健診コース")}</div>
          <select
            name="course"
            value={options.course}
            onChange={handleInputChange}
            className={styles.selectInput}
          >
            <option value="">{t("選択してください")}</option>
            <option value="A">{t("生活習慣病A")}</option>
            <option value="B">{t("生活習慣病B")}</option>
            <option value="C">{t("女性生活習慣病C")}</option>
            <option value="B1">{t("生活習慣病B1")}</option>
            <option value="D">{t("人間ドック")}</option>
            <option value="L">{t("人間ドック（婦人科含む）")}</option>
            <option value="T">{t("特定健診")}</option>
          </select>
        </div>
        <div style={{ display: options.course !== "" ? "none" : "none" }}>
          <table className={styles.targetMemberTable}>
            <thead>
              <tr>
                <th colSpan={3}>被保険者 男性</th>
                <th colSpan={3}>被保険者 女性</th>
                <th colSpan={3}>被扶養者 男性</th>
                <th colSpan={3}>被扶養者 女性</th>
              </tr>
              <tr>
                <th>40歳以上</th>
                <th>35～39歳</th>
                <th>34歳以下</th>
                <th>40歳以上</th>
                <th>35～39歳</th>
                <th>34歳以下</th>
                <th>40歳以上</th>
                <th>35～39歳</th>
                <th>34歳以下</th>
                <th>40歳以上</th>
                <th>35～39歳</th>
                <th>34歳以下</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  display: options.course === "A" ? "table-row" : "none",
                }}
              >
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
              </tr>
              <tr
                style={{
                  display: options.course === "B" ? "table-row" : "none",
                }}
              >
                <td>○</td>
                <td>○</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>―</td>
              </tr>
              <tr
                style={{
                  display: options.course === "C" ? "table-row" : "none",
                }}
              >
                <td>―</td>
                <td>―</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>―</td>
                <td>―</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
              </tr>
              <tr
                style={{
                  display: options.course === "C1" ? "table-row" : "none",
                }}
              >
                <td>―</td>
                <td>―</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>―</td>
                <td>―</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
              </tr>
              <tr
                style={{
                  display: options.course === "D" ? "table-row" : "none",
                }}
              >
                <td>○</td>
                <td>○</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>―</td>
                <td>○</td>
                <td>○</td>
                <td>―</td>
              </tr>
              <tr
                style={{
                  display:
                    options.course === "toshinkyo_tokutei"
                      ? "table-row"
                      : "none",
                }}
              >
                <td>○</td>
                <td>―</td>
                <td>―</td>
                <td>○</td>
                <td>―</td>
                <td>―</td>
                <td>○</td>
                <td>―</td>
                <td>―</td>
                <td>○</td>
                <td>―</td>
                <td>―</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OptionSelect;
